import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Outlet, Link as RouterLink, useLocation } from "react-router-dom";

import { Box } from "@mui/material";

import Header from "src/layouts/BaseLayout/Header";
import { MapStateProvider } from "src/contexts/MapStateContext";

  const BaseLayout = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    //console.log('Current path:', location.pathname);
  }, [location.pathname]);

  return (
    <MapStateProvider>
      <Box>
        <Header />
        {children || <Outlet />}
      </Box>
    </MapStateProvider>
  );
};

BaseLayout.propTypes = {
  children: PropTypes.node,
};

export default BaseLayout;
